import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, SectionHeader, TitleHeader, Typography } from 'web-library';
import EntryProofSearchFilterTable from './EntryProofSearchFilterTable';

const CoordinatorMakeEntryProofRequests = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('entryProof->>MakingRequestListing.EntryProof')} />
      <ContentTemplate transparent continuous type="full">
        <SectionHeader title={t('entryProof->>MakingRequestListing.DownloadEntryProofs')} />
        <Typography>
          {t('entryProof->>MakingRequestListing.SearchOrSelectCandidateInstruction')}
        </Typography>
        <EntryProofSearchFilterTable />
      </ContentTemplate>
    </>
  );
};

export default CoordinatorMakeEntryProofRequests;
